module.exports = __webpack_public_path__ + "static/media/abilitya-logo.9615f9c9.png";